import React, { Fragment, useContext, useState } from "react";
import {Link, useHistory} from "react-router-dom"
import Cart from "../Cart/Cart";
import {Card} from "react-bootstrap"
import {Button} from "react-bootstrap"
import { Row, Col } from "reactstrap";
import { useMediaQuery } from 'react-responsive'
import HorizontalScroll from 'react-scroll-horizontal'
import Header from "./Header";
import AboutUs from "./AboutUs";
import { ContactUs } from "./ContactUs";
import {Footer} from './Footer';
import { Waypoint } from 'react-waypoint';
import { ComponentContext } from "../Context/Context";

const MainPage=()=>{
  const {comp,setComp}=useContext(ComponentContext);
  const history=useHistory();
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-device-width: 1224px)'
  })
  const isTabletOrMobileDevice = useMediaQuery({
    query: '(max-device-width: 1224px)'
  })
    return(
    <Fragment >
      <Header/>
    <AboutUs/>
    <div style={{marginTop:"55px"}} id="golditems" >
      <h3 style={{textAlign:"center",fontFamily:"Lobester"}} className="ss">Gold Items</h3>
    {isDesktopOrLaptop && <>
      <ul class="list-group list-group-flush" id="items" style={{marginBottom:"20px",display:"block", fontFamily: 'Lobster'}}>
      <Link to="/rings" className="linkcss">
      <div class="card-header" style={{fontSize:"20px"}}>
        <Row>
          <Col >
      <img src={require("../rings.jpg")} style={{paddingLeft:"10px",height:"130px",width:"50%"}} class="card-img-top" alt="..."/>
        </Col>
      <Col >
        <div style={{marginTop:"12%",float:"left"}}>
        <h2 style={{color:"#000"}}>Rings</h2>
        </div>
        
      </Col>
      </Row>
      </div>
      </Link>

      <Link to="/necklace"  className="linkcss">
      <div class="card-header" style={{fontSize:"20px"}}>
        <Row>
          <Col >
      <img src={require("../necklace.jpg")} style={{height:"130px",width:"50%"}} class="card-img-top" alt="..."/>
        </Col>
      <Col >
        <div style={{marginTop:"12%",float:"left"}}>
        <h2 style={{color:"#000"}}>Necklace</h2>
        </div>  
      </Col>
      </Row>
      </div>
      </Link>

      <Link to="/bracelet"  className="linkcss">
      <div class="card-header" style={{fontSize:"20px"}}>
        <Row>
          <Col >
      <img src={require("../bracelet.jpeg")} style={{height:"130px",width:"50%"}} class="card-img-top" alt="..."/>
        </Col>
      <Col >
        <div style={{marginTop:"12%",float:"left"}}>
        <h2 style={{color:"#000"}}>Bracelets</h2>
        </div>
        
      </Col>
      </Row>
      </div>
      </Link>

      <Link to="/coins" className="linkcss">
      <div class="card-header" style={{fontSize:"20px"}}>
        <Row>
          <Col >
      <img src={require("../coins.jpg")} style={{height:"130px",width:"50%"}} class="card-img-top" alt="..."/>
        </Col>
      <Col >
        <div style={{marginTop:"12%",float:"left"}}>
        <h2 style={{color:"#000"}}>Coins</h2>
        </div>
        
      </Col>
      </Row>
      </div>
      </Link>

      <Link to="/chains" className="linkcss">
      <div class="card-header" style={{fontSize:"20px"}}>
        <Row>
          <Col >
      <img src={require("../chains.jpg")} style={{height:"130px",width:"50%"}} class="card-img-top" alt="..."/>
        </Col>
      <Col >
        <div style={{marginTop:"12%",float:"left"}}>
        <h2 style={{color:"#000"}}>Chains</h2>
        </div>
        
      </Col>
      </Row>
      </div>
      </Link>

      <Link to="/stirs" className="linkcss">
      <div class="card-header" style={{fontSize:"20px"}}>
        <Row>
          <Col >
      <img src={require("../stirs.jpg")} style={{height:"130px",width:"50%"}} class="card-img-top" alt="..."/>
        </Col>
      <Col >
        <div style={{marginTop:"12%",float:"left"}}>
        <h2 style={{color:"#000"}}>Ear Rings</h2>
        </div>
        
      </Col>
      </Row>
      </div>
      </Link>

      <Link to="/silver" className="linkcss">
      <div class="card-header" style={{fontSize:"20px"}}>
        <Row>
          <Col >
      <img src={require("../silverring.jpg")} style={{height:"140px",width:"50%"}} class="card-img-top" alt="..."/>
        </Col>
      <Col >
        <div style={{marginTop:"12%",float:"left"}}>
        <h2 style={{color:"#000"}}>Silver Rings & Bracelets</h2>
        </div>
      </Col>
      </Row>
      </div>
      </Link>      
   
      </ul>
      <div id="aboutus"  style={{padding:"13px"}}>
      <h2 style={{marginTop:"20px",textAlign:"center"}} className="ss">Contact Us</h2>

      <div class="card" style={{width:"50%"}}>
        <Row>
          <Col>
    <img src={require("../sreenu.jpeg")} style={{width:"140px",height:"140px",borderRadius:"50%"}} class="card-img-top" alt="..."/>
          </Col>
          <Col>
          <div class="card-body">
        <h5 class="card-title">Thatavarthi Sreenivasulu</h5>
        <h6><Link to="/auth" style={{color:"#000",textDecoration:"none"}}>Proprietor,Siri Jewellers</Link></h6>
      </div>
          </Col>
        </Row>  
    </div>
    <div class="card" style={{width:"50%"}}>
        <Row>
          <Col>
          <div class="card-body" >
        {/* <h7>Web App Designed by:</h7> */}
        <h5 class="card-title">Thatavarthi Sreeram</h5>
        <h6><a href="https://github.com/SreeramThatavarthi" style={{color:"#000"}}>Web Developer</a></h6>
      </div>
          </Col>
          <Col>
    <img src={require("../IMG-20190217-WA0031.jpg")} style={{width:"140px",height:"140px",borderRadius:"50%"}} class="card-img-top" alt="..."/>
          </Col>
        </Row>
    </div>
      </div>
      </>
     }
     {
       isTabletOrMobileDevice && <>
        <ul id="items" class="list-group list-group-flush" style={{marginBottom:"20px",fontFamily: 'Lobster'}}>
        <Link to="/rings">
        <div class="card-header" style={{fontSize:"20px"}} onClick={()=>setComp('rings')}>
          <Row>
            <Col >
        <img src={require("../rings.jpg")} style={{height:"70px",width:"80%"}} class="card-img-top" alt="..."/>
          </Col>
        <Col >
          <div style={{marginTop:"14%",float:"left"}}>
          <h4 style={{color:"#000"}}>Rings</h4>
          </div>   
        </Col>
        </Row>
        </div>
        </Link>
  
        <Link to="/necklace"  onClick={()=>setComp('necklace')}>
        <div class="card-header" style={{fontSize:"20px"}}>
          <Row>
            <Col >
        <img src={require("../necklace.jpg")} style={{height:"70px",width:"80%"}} class="card-img-top" alt="..."/>
          </Col>
        <Col >
          <div style={{marginTop:"14%",float:"left"}}>
          <h4 style={{color:"#000"}}>Necklace</h4>
          </div>
        </Col>
        </Row>
        </div>
        </Link>

        <Link to="/coins" onClick={()=>setComp('coins')}>
        <div class="card-header" style={{fontSize:"20px"}} >
          <Row>
            <Col >
        <img src={require("../coins.jpg")} style={{height:"70px",width:"80%"}} class="card-img-top" alt="..."/>
          </Col>
        <Col >
          <div style={{marginTop:"14%",float:"left"}}>
          <h4 style={{color:"#000"}}>Coins</h4>
          </div>
        </Col>
        </Row>
        </div>
        </Link>

        <Link to="/bracelet" onClick={()=>setComp('bracelet')}>
        <div class="card-header" style={{fontSize:"20px"}} >
          <Row>
            <Col >
        <img src={require("../bracelet.jpeg")} style={{height:"70px",width:"80%"}} class="card-img-top" alt="..."/>
          </Col>
        <Col >
          <div style={{marginTop:"14%",float:"left"}}>
          <h4 style={{color:"#000"}}>Bracelets</h4>
          </div>
        </Col>
        </Row>
        </div>
        </Link>

        <Link to="/chains" onClick={()=>setComp('chains')}>
        <div class="card-header" style={{fontSize:"20px"}} >
          <Row>
            <Col >
        <img src={require("../chains.jpg")} style={{height:"70px",width:"80%"}} class="card-img-top" alt="..."/>
          </Col>
        <Col >
          <div style={{marginTop:"14%",float:"left"}}>
          <h4 style={{color:"#000"}}>Chains</h4>
          </div>
        </Col>
        </Row>
        </div>
        </Link>
  
        <Link to="/stirs" onClick={()=>setComp('stirs')}>
        <div class="card-header" style={{fontSize:"20px"}} >
          <Row>
            <Col >
        <img src={require("../stirs.jpg")} style={{height:"70px",width:"80%"}} class="card-img-top" alt="..."/>
          </Col>
        <Col >
          <div style={{marginTop:"14%",float:"left"}}>
          <h4 style={{color:"#000"}}>Ear Rings</h4>
          </div>
          
        </Col>
        </Row>
        </div>
        </Link>    

        <Link to="/silver">
        <div class="card-header" style={{fontSize:"20px"}}>
          <Row>
            <Col >
        <img src={require("../silverring.jpg")} style={{height:"70px",width:"80%"}} class="card-img-top" alt="..."/>
          </Col>
        <Col >
          <div style={{marginTop:"14%",float:"left"}}>
          <h4 style={{color:"#000"}}>Silver Rings & Bracelets</h4>
          </div>
        </Col>
        </Row>
        </div>
        </Link>
        </ul>
        <div id="aboutus" style={{padding:"13px"}}>
        <h2 style={{marginTop:"40px",textAlign:"center"}} className="ss">Contact Us</h2>
        <div class="card">
          <Row>
            <Col>
               <img src={require("../sreenu.jpeg")} style={{width:"140px",height:"140px",borderRadius:"50%"}} class="card-img-top" alt="..."/>
            </Col>
          <Col>
            <div class="card-body">
              <h5 class="card-title">Thatavarthi Sreenivasulu</h5>
              <h6><Link to="/auth" style={{color:"#000",textDecoration:"none"}}>Proprietor,Siri Jewellers</Link></h6>
            </div>
          </Col>
         </Row>  
        </div>
    <div class="card">
        <Row>
          <Col>
          <div class="card-body" >
        {/* <h7>Web App Designed by:</h7> */}
        <h5 class="card-title">Thatavarthi Sreeram</h5>
        <h6><a href="https://github.com/SreeramThatavarthi" style={{color:"#000"}}>Web Developer</a></h6>
      </div>
          </Col>
          <Col>
    <img src={require("../IMG-20190217-WA0031.jpg")} style={{width:"140px",height:"140px",borderRadius:"50%"}} class="card-img-top" alt="..."/>
          </Col>
        </Row>
    </div>
      </div>
        </>
      }
    </div>
    <ContactUs/>
    <Footer/>
    </Fragment>
    )
}

export default MainPage;